import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { Blank } from 'store/types/common';

interface blankState {
	blank: Blank | null;
	stepData: Partial<Blank> | null;
	isDataSubmitted: boolean;
}

const initialState: blankState = {
	blank: null,
	stepData: null,
	isDataSubmitted: false,
};

const saveToLocalStorage = (key: string, value: any) => {
	try {
		localStorage.setItem(key, JSON.stringify(value));
	} catch (error) {
		console.error('Ошибка при сохранении в localStorage:', error);
	}
};

const loadFromLocalStorage = (key: string) => {
	try {
		const data = localStorage.getItem(key);
		return data ? JSON.parse(data) : null;
	} catch (error) {
		console.error('Ошибка при загрузке из localStorage:', error);
		return null;
	}
};

export const blankSlice = createSlice({
	initialState: loadFromLocalStorage('blankState') || initialState,
	name: 'blankSlice',
	reducers: {
		setBlank: (state, action: PayloadAction<Partial<Blank>>) => {
			state.blank = { ...state.blank, ...action.payload };
			saveToLocalStorage('blankState', state);
		},
		setStepData: (state, action: PayloadAction<Partial<Blank>>) => {
			state.stepData = action.payload;
			state.isDataSubmitted = false;
			saveToLocalStorage('blankState', state);
			console.log(state.stepData);
		},

		markDataAsSubmitted: (state) => {
			state.isDataSubmitted = true;
			saveToLocalStorage('blankState', state);
		},
		clearStepData: (state) => {
			state.stepData = null;
			state.isDataSubmitted = false;
			saveToLocalStorage('blankState', state);
		},
	},
});

export const { setBlank, setStepData, markDataAsSubmitted, clearStepData } = blankSlice.actions;
export { loadFromLocalStorage };
export default blankSlice.reducer;
